module.exports = __webpack_public_path__ + "img/t21.586bf7e2.png";